<template>
  <div class="RegisterCardStyle">
    <SuccessBase :title="$t('common.common_password-reset')" />
  </div>
</template>

<script>
import { SuccessBase } from '@/components/layouts'
export default {
  components: {
    SuccessBase
  }
}
</script>
